declare const CONFIG: any;
const $config: any = CONFIG;

export { $config };
